module.exports = __webpack_public_path__ + "static/media/certification-icon.9a1ca66f.svg";